var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.el,{tag:"component",class:[_vm.marginClass, ( _obj = {}, _obj[_vm.borders.top] = _vm.border, _obj )]},[_vm._t("default",[_vm._v("Add stuff here!")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }